/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { OrderDeliveryDateMetadataDtoModel, OrderDeliveryDateMetadataDtoModelType } from "./OrderDeliveryDateMetadataDtoModel"
import { OrderDeliveryDateMetadataDtoModelSelector } from "./OrderDeliveryDateMetadataDtoModel.base"
import { OutputMetadataUnionModelSelector } from "./OutputMetadataUnionModelSelector"
import { ScheduleActionMetadataDtoModel, ScheduleActionMetadataDtoModelType } from "./ScheduleActionMetadataDtoModel"
import { ScheduleActionMetadataDtoModelSelector } from "./ScheduleActionMetadataDtoModel.base"
import { RootStoreType } from "./index"


/**
 * PlanningActionOutputDtoBase
 * auto generated base class for the model PlanningActionOutputDtoModel.
 */
export const PlanningActionOutputDtoModelBase = ModelBase
  .named('PlanningActionOutputDto')
  .props({
    __typename: types.optional(types.literal("PlanningActionOutputDto"), "PlanningActionOutputDto"),
    error: types.union(types.undefined, types.null, types.string),
    metadata: types.union(types.undefined, types.null, types.late((): any => ScheduleActionMetadataDtoModel)),
    details: types.union(types.undefined, types.null, types.union(types.late((): any => ScheduleActionMetadataDtoModel), types.late((): any => OrderDeliveryDateMetadataDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlanningActionOutputDtoModelSelector extends QueryBuilder {
  get error() { return this.__attr(`error`) }
  metadata(builder: string | ScheduleActionMetadataDtoModelSelector | ((selector: ScheduleActionMetadataDtoModelSelector) => ScheduleActionMetadataDtoModelSelector) | undefined) { return this.__child(`metadata`, ScheduleActionMetadataDtoModelSelector, builder) }
  details(builder: string | OutputMetadataUnionModelSelector | ((selector: OutputMetadataUnionModelSelector) => OutputMetadataUnionModelSelector) | undefined) { return this.__child(`details`, OutputMetadataUnionModelSelector, builder) }
}
export function selectFromPlanningActionOutputDto() {
  return new PlanningActionOutputDtoModelSelector()
}

export const planningActionOutputDtoModelPrimitives = selectFromPlanningActionOutputDto().error
